import React from "react";
import "./FaqMenuCard.css";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import { Avatar, Chip, ListItemAvatar } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function FaqMenuTypeList(props) {
  // console.log("FaqMenuTypeList Entered");
  const classes = useStyles();
  // console.log("props data list: ", props.faqListData);

  let faqListData = props.faqListData;

  return (
    <List className={classes.root}>
      {faqListData.map((data, i) => (
        <ListItem key={i}>
          <ListItemAvatar>
            <Chip label={i+1} size="small"/>
          </ListItemAvatar>
          <ListItemText primary={data} />
        </ListItem>
      ))}
    </List>
  );
}
